var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _vm.nuevo
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-md-12" },
                [
                  _c(
                    "input-field",
                    {
                      staticClass: "input-field--stretch",
                      attrs: {
                        id: "numeroContenedor",
                        bold: "",
                        fontSize: "150%"
                      },
                      model: {
                        value: _vm.form.number,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "number", $$v)
                        },
                        expression: "form.number"
                      }
                    },
                    [
                      _c("h3", { staticStyle: { color: "black" } }, [
                        _vm._v("Unidad")
                      ]),
                      _vm._v(" "),
                      _vm.errores.number
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.number[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _c("h3", [
                _c("a", { attrs: { href: "#" }, on: { click: _vm.verFotos } }, [
                  _vm._v(
                    "\n          Unidad " +
                      _vm._s(_vm.numeroContenedor) +
                      "\n        "
                  )
                ])
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            !_vm.MostrarBotonGuardar
              ? _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.actualizar }
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Guardar")])
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.crear }
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Guardar")])
                  ]
                ),
            _vm._v(" "),
            _vm.puede_finalizar_in && _vm.nuevo && !_vm.MostrarBotonGuardar
              ? _c(
                  "button",
                  {
                    staticClass: "btn-primary",
                    attrs: { disabled: _vm.finalizando, type: "button" },
                    on: { click: _vm.finalizar }
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Finalizar")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.in.eir && !_vm.MostrarBotonGuardar,
                    expression: "form.in.eir && !MostrarBotonGuardar"
                  }
                ],
                staticClass: "btn--outline btn-info",
                on: { click: _vm.imprimirEirIn }
              },
              [_c("span", [_vm._v("EIR caja")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.in.eir_maquina,
                    expression: "form.in.eir_maquina"
                  }
                ],
                staticClass: "btn--outline btn-secondary",
                on: { click: _vm.imprimirEirMaquina }
              },
              [_c("span", [_vm._v("EIR máquina")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.out.eir,
                    expression: "form.out.eir"
                  }
                ],
                staticClass: "btn--outline btn-success",
                on: { click: _vm.imprimirEirOut }
              },
              [_c("span", [_vm._v("EIR out")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.MostrarBotonGuardar && _vm.puede_enviar_edi_in,
                    expression: "!MostrarBotonGuardar && puede_enviar_edi_in"
                  }
                ],
                staticClass: "btn--outline btn-info",
                on: {
                  click: function($event) {
                    return _vm.generarEDI("IN")
                  }
                }
              },
              [_c("span", [_vm._v("EDI in")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.outDisabled &&
                      _vm.tipo_registro !== "OUT" &&
                      _vm.puede_enviar_edi_out,
                    expression:
                      "!outDisabled && tipo_registro !== 'OUT' && puede_enviar_edi_out"
                  }
                ],
                staticClass: "btn--outline btn-secondary",
                on: {
                  click: function($event) {
                    return _vm.generarEDI("OUT")
                  }
                }
              },
              [_c("span", [_vm._v("EDI out")])]
            ),
            _vm._v(" "),
            !_vm.MostrarBotonGuardar && _vm.puede_editar_detalles
              ? _c(
                  "button",
                  {
                    staticClass: "btn-primary btn--outline",
                    attrs: { type: "button" },
                    on: { click: _vm.mostrarDetalles }
                  },
                  [
                    _c("i", { staticClass: "fa fa-table" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Detalles")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.nuevo
              ? _c(
                  "button",
                  {
                    staticClass: "btn-secondary btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.nuevoRegistro }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Nuevo")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.puede_eliminar && !_vm.MostrarBotonGuardar,
                    expression: "puede_eliminar && !MostrarBotonGuardar"
                  }
                ],
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: { click: _vm.eliminarUnidad }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _vm._v(" "),
                _c("span", [_vm._v("Eliminar")])
              ]
            ),
            _vm._v(" "),
            !_vm.nuevo
              ? _c(
                  "button",
                  {
                    staticClass: "btn-danger btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.cerrarUnidad }
                  },
                  [
                    _c("i", { staticClass: "fa fa-ban" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Cancelar")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-info btn--text",
                attrs: { type: "button" },
                on: { click: _vm.mostrarAtajos }
              },
              [
                _c("i", { staticClass: "fa fa-question-circle" }),
                _vm._v(" "),
                _c("span", [_vm._v("Atajos")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "layout__main-form" }, [
            _c(
              "details",
              {
                staticClass: "card card--collapsible mt-3 mb-3",
                attrs: { id: "IN" }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                value: this.form.number,
                                readonly: "",
                                id: "number"
                              }
                            },
                            [_vm._v("Number:")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.nuevo,
                            expression: "nuevo"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-3"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-field select2",
                            class: {
                              "select2--disabled": _vm.tipo_registro === "OUT"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "select2-field select2-field--stretch"
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    id: "yard",
                                    label: "name",
                                    options: _vm.yards,
                                    disabled:
                                      _vm.total_loss || !_vm.puede_editar_in
                                  },
                                  on: { input: _vm.inputYard },
                                  model: {
                                    value: _vm.selectedYard,
                                    callback: function($$v) {
                                      _vm.selectedYard = $$v
                                    },
                                    expression: "selectedYard"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "yard" } }, [
                                  _vm._v("Yard:")
                                ]),
                                _vm._v(" "),
                                _vm.errores.yard_code
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.errores.yard_code[0])
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                id: "turn_in",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_in,
                                readonly: _vm.tipo_registro === "OUT"
                              },
                              model: {
                                value: _vm.form.in.turn_in,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.in, "turn_in", $$v)
                                },
                                expression: "form.in.turn_in"
                              }
                            },
                            [_vm._v("Turn IN:")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                id: "eir",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_in,
                                readonly: _vm.tipo_registro === "OUT"
                              },
                              model: {
                                value: _vm.form.in.eir,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.in, "eir", $$v)
                                },
                                expression: "form.in.eir"
                              }
                            },
                            [_vm._v("Eir:")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: {
                            "select2--disabled": _vm.tipo_registro === "OUT"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_in,
                                  id: "size",
                                  label: "size",
                                  options: _vm.sizes
                                },
                                model: {
                                  value: _vm.form.in.size,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.in, "size", $$v)
                                  },
                                  expression: "form.in.size"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "size" } }, [
                                _vm._v("Size:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: {
                            "select2--disabled": _vm.tipo_registro === "OUT"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "type",
                                  label: "descripcion",
                                  options: _vm.types,
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_in
                                },
                                on: { input: _vm.inputType },
                                model: {
                                  value: _vm.selectedType,
                                  callback: function($$v) {
                                    _vm.selectedType = $$v
                                  },
                                  expression: "selectedType"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "type" } }, [
                                _vm._v("Type:")
                              ]),
                              _vm._v(" "),
                              _vm.errores["in.type_container_code"]
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores[
                                              "in.type_container_code"
                                            ][0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("date-picker", {
                            attrs: {
                              id: "gate_date_in",
                              type: "dateTime",
                              locale: "es",
                              format: "YYYY-MM-DD HH:mm",
                              formatted: "YYYY-MM-DD HH:mm",
                              disabled:
                                _vm.total_loss ||
                                !_vm.puede_editar_in ||
                                _vm.tipo_registro === "OUT" ||
                                (!_vm.MostrarBotonGuardar &&
                                  !_vm.puede_editar_gate_in)
                            },
                            model: {
                              value: _vm.form.in.gate_date,
                              callback: function($$v) {
                                _vm.$set(_vm.form.in, "gate_date", $$v)
                              },
                              expression: "form.in.gate_date"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Gate Date:")]),
                          _vm._v(" "),
                          _vm.errores["in.gate_date"]
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores["in.gate_date"][0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_in,
                                readonly: _vm.tipo_registro === "OUT",
                                stretch: "",
                                id: "tara"
                              },
                              model: {
                                value: _vm.form.in.tara,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.in, "tara", $$v)
                                },
                                expression: "form.in.tara"
                              }
                            },
                            [_vm._v("Tara")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_in,
                                readonly: _vm.tipo_registro === "OUT",
                                id: "gross"
                              },
                              model: {
                                value: _vm.form.in.gross,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.in, "gross", $$v)
                                },
                                expression: "form.in.gross"
                              }
                            },
                            [_vm._v("Gross")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_in,
                                readonly: _vm.tipo_registro === "OUT",
                                id: "booking_in"
                              },
                              model: {
                                value: _vm.form.in.booking,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.in, "booking", $$v)
                                },
                                expression: "form.in.booking"
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Booking:\n                    "
                              ),
                              _vm.errores["in.booking"]
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores["in.booking"][0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: {
                            "select2--disabled": _vm.tipo_registro === "OUT"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "trucking_in",
                                  options: _vm.optionsTruckingIn,
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_in,
                                  taggable: ""
                                },
                                on: {
                                  input: _vm.inputTruckCo,
                                  search: _vm.fetchTruckingIn
                                },
                                model: {
                                  value: _vm.form.in.truck_co,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.in, "truck_co", $$v)
                                  },
                                  expression: "form.in.truck_co"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "truckIn" } }, [
                                _vm._v("Truck Co:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_in,
                                readonly: _vm.tipo_registro === "OUT",
                                stretch: "",
                                id: "cedula_conductor_in"
                              },
                              model: {
                                value: _vm.form.in.cedula_conductor,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.in, "cedula_conductor", $$v)
                                },
                                expression: "form.in.cedula_conductor"
                              }
                            },
                            [_vm._v("C.I_Conductor:")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: {
                            "select2--disabled": _vm.tipo_registro === "OUT"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "shipper_in",
                                  options: _vm.optionsShipperIn,
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_in,
                                  taggable: ""
                                },
                                on: {
                                  input: _vm.inputShipper,
                                  search: _vm.fetchShipperIn
                                },
                                model: {
                                  value: _vm.form.in.shipper,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.in, "shipper", $$v)
                                  },
                                  expression: "form.in.shipper"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "shipper" } }, [
                                _vm._v("Shipper:")
                              ]),
                              _vm._v(" "),
                              _vm.errores["in.shipper"]
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores["in.shipper"][0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: {
                            "select2--disabled": _vm.tipo_registro === "OUT"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "vessel",
                                  options: _vm.optionsVesselIn,
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_in,
                                  taggable: ""
                                },
                                on: {
                                  input: _vm.inputVessel,
                                  search: _vm.fetchVesselIn
                                },
                                model: {
                                  value: _vm.form.in.vessel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.in, "vessel", $$v)
                                  },
                                  expression: "form.in.vessel"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "vessel" } }, [
                                _vm._v("Vessel:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: {
                            "select2--disabled": _vm.tipo_registro === "OUT"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "customer",
                                  options: _vm.customers,
                                  label: "nombre",
                                  disabled:
                                    _vm.total_loss ||
                                    !_vm.puede_editar_in ||
                                    !_vm.MostrarBotonGuardar
                                },
                                on: { input: _vm.inputCustomer },
                                model: {
                                  value: _vm.selectedCustomer,
                                  callback: function($$v) {
                                    _vm.selectedCustomer = $$v
                                  },
                                  expression: "selectedCustomer"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "customer" } }, [
                                _vm._v("Customer:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: {
                            "select2--disabled": _vm.tipo_registro === "OUT"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_in,
                                  options: _vm.damages,
                                  id: "type_dmg"
                                },
                                model: {
                                  value: _vm.form.in.type_dmg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.in, "type_dmg", $$v)
                                  },
                                  expression: "form.in.type_dmg"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "type_dmg" } }, [
                                _vm._v("Type Dmg:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: {
                            "select2--disabled": _vm.tipo_registro === "OUT"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_in,
                                  id: "model_box",
                                  options: _vm.modelBox
                                },
                                model: {
                                  value: _vm.form.in.model_box,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.in, "model_box", $$v)
                                  },
                                  expression: "form.in.model_box"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "model_box" } }, [
                                _vm._v("Model Box:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_in,
                                readonly: _vm.tipo_registro === "OUT",
                                stretch: "",
                                id: "placa"
                              },
                              model: {
                                value: _vm.form.in.placa,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.in, "placa", $$v)
                                },
                                expression: "form.in.placa"
                              }
                            },
                            [_vm._v("Placa:")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c("div", { staticClass: "form-field mt-2" }, [
                          _c(
                            "label",
                            {
                              staticClass: "input-field__label",
                              attrs: { for: "archivo" }
                            },
                            [_vm._v("Foto de cédula")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            attrs: {
                              type: "file",
                              accept: "image/*",
                              name: "archivo",
                              id: "archivo"
                            },
                            on: { change: _vm.imgSelected }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.imagePreview
                      ? _c("div", { staticClass: "col-xs-12 col-md-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn-secondary btn--text",
                              attrs: { type: "button" },
                              on: { click: _vm.mostrarImg }
                            },
                            [_c("i", { staticClass: "fa fa-eye" })]
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "textarea-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_in,
                                readonly: _vm.tipo_registro === "OUT",
                                stretch: "",
                                id: "remarks"
                              },
                              model: {
                                value: _vm.form.in.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.in, "remarks", $$v)
                                },
                                expression: "form.in.remarks"
                              }
                            },
                            [_vm._v("Remarks:")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", [
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.raps,
                              expression: "form.in.raps"
                            }
                          ],
                          attrs: {
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.form.in.raps)
                              ? _vm._i(_vm.form.in.raps, null) > -1
                              : _vm.form.in.raps
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.form.in.raps,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "raps",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "raps",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form.in, "raps", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("RAPS")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.damage,
                              expression: "form.in.damage"
                            }
                          ],
                          attrs: {
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.form.in.damage)
                              ? _vm._i(_vm.form.in.damage, null) > -1
                              : _vm.form.in.damage
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.form.in.damage,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "damage",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "damage",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form.in, "damage", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Damage")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.pti,
                              expression: "form.in.pti"
                            }
                          ],
                          attrs: {
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.form.in.pti)
                              ? _vm._i(_vm.form.in.pti, null) > -1
                              : _vm.form.in.pti
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.form.in.pti,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "pti",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "pti",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form.in, "pti", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("PTI")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.full,
                              expression: "form.in.full"
                            }
                          ],
                          attrs: {
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.form.in.full)
                              ? _vm._i(_vm.form.in.full, null) > -1
                              : _vm.form.in.full
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.form.in.full,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "full",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "full",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form.in, "full", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Full")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.automatico,
                              expression: "form.in.automatico"
                            }
                          ],
                          attrs: {
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.form.in.automatico)
                              ? _vm._i(_vm.form.in.automatico, null) > -1
                              : _vm.form.in.automatico
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.form.in.automatico,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "automatico",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form.in,
                                      "automatico",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form.in, "automatico", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Automático")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.type,
                              expression: "form.in.type"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "type_in",
                            id: "type_pto",
                            value: "CY",
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT"
                          },
                          domProps: { checked: _vm._q(_vm.form.in.type, "CY") },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form.in, "type", "CY")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("PTO")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.type,
                              expression: "form.in.type"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "type_in",
                            id: "type_dev",
                            value: "CF",
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT"
                          },
                          domProps: { checked: _vm._q(_vm.form.in.type, "CF") },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form.in, "type", "CF")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("DEV")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.type,
                              expression: "form.in.type"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "type_in",
                            id: "type_ccl",
                            value: "SD",
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT"
                          },
                          domProps: { checked: _vm._q(_vm.form.in.type, "SD") },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form.in, "type", "SD")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("CCL")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.type,
                              expression: "form.in.type"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "type_in",
                            id: "type_pos",
                            value: "PO",
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT"
                          },
                          domProps: { checked: _vm._q(_vm.form.in.type, "PO") },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form.in, "type", "PO")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("POS")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.in.type,
                              expression: "form.in.type"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "type_in",
                            id: "type_acc",
                            value: "AC",
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_in ||
                              _vm.tipo_registro === "OUT"
                          },
                          domProps: { checked: _vm._q(_vm.form.in.type, "AC") },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form.in, "type", "AC")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("ACC")])
                      ]),
                      _vm._v(" "),
                      _vm.errores["in.type"]
                        ? _c("label", [
                            _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                staticStyle: { width: "auto" },
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores["in.type"][0]))
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "details",
              {
                staticClass: "card card--collapsible mt-3 mb-3",
                attrs: { id: "OUT" }
              },
              [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("date-picker", {
                            attrs: {
                              id: "gate_date_out",
                              type: "dateTime",
                              locale: "es",
                              format: "YYYY-MM-DD HH:mm",
                              formatted: "YYYY-MM-DD HH:mm",
                              disabled:
                                _vm.total_loss ||
                                !_vm.puede_editar_out ||
                                _vm.outDisabled ||
                                (!_vm.MostrarBotonGuardar &&
                                  !_vm.puede_editar_gate_out &&
                                  _vm.tipo_registro !== "OUT")
                            },
                            model: {
                              value: _vm.form.out.gate_date,
                              callback: function($$v) {
                                _vm.$set(_vm.form.out, "gate_date", $$v)
                              },
                              expression: "form.out.gate_date"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Gate Date:")])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                stretch: "",
                                id: "turn_out"
                              },
                              model: {
                                value: _vm.form.out.turn_out,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "turn_out", $$v)
                                },
                                expression: "form.out.turn_out"
                              }
                            },
                            [_vm._v("Turn OUT:")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                stretch: "",
                                id: "e_ir_out"
                              },
                              model: {
                                value: _vm.form.out.eir,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "eir", $$v)
                                },
                                expression: "form.out.eir"
                              }
                            },
                            [_vm._v("Eir:")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                stretch: "",
                                id: "booking_out"
                              },
                              model: {
                                value: _vm.form.out.booking,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "booking", $$v)
                                },
                                expression: "form.out.booking"
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Booking\n                    "
                              ),
                              _vm.errores["out.booking"]
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores["out.booking"][0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                id: "vessel_out"
                              },
                              model: {
                                value: _vm.form.out.vessel,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "vessel", $$v)
                                },
                                expression: "form.out.vessel"
                              }
                            },
                            [_vm._v("Vessel")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: { "select2--disabled": _vm.outDisabled }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "shipper_out",
                                  options: _vm.optionsShipperOut,
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_out,
                                  taggable: ""
                                },
                                on: {
                                  input: _vm.inputShipperOut,
                                  search: _vm.fetchShipperOut
                                },
                                model: {
                                  value: _vm.form.out.shipper,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.out, "shipper", $$v)
                                  },
                                  expression: "form.out.shipper"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "shipper_out" } }, [
                                _vm._v("Shipper:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: { "select2--disabled": _vm.outDisabled }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "truck_out",
                                  options: _vm.optionsTruckingOut,
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_out,
                                  taggable: ""
                                },
                                on: {
                                  input: _vm.inputTruckCoOut,
                                  search: _vm.fetchTruckingOut
                                },
                                model: {
                                  value: _vm.form.out.truck_co,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.out, "truck_co", $$v)
                                  },
                                  expression: "form.out.truck_co"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "truck_co_out" } }, [
                                _vm._v("Truck Co:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                id: "cedula_conductor_out"
                              },
                              model: {
                                value: _vm.form.out.cedula_conductor,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.out,
                                    "cedula_conductor",
                                    $$v
                                  )
                                },
                                expression: "form.out.cedula_conductor"
                              }
                            },
                            [_vm._v("C.I_Conductor:")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                id: "voyage_out"
                              },
                              model: {
                                value: _vm.form.out.voyage,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "voyage", $$v)
                                },
                                expression: "form.out.voyage"
                              }
                            },
                            [_vm._v("Voyage")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                id: "payload_out"
                              },
                              model: {
                                value: _vm.form.out.payload,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "payload", $$v)
                                },
                                expression: "form.out.payload"
                              }
                            },
                            [_vm._v("Payload")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-field select2",
                          class: { "select2--disabled": _vm.outDisabled }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "select2-field select2-field--stretch"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "chassis_out",
                                  options: _vm.chassis,
                                  disabled:
                                    _vm.total_loss || !_vm.puede_editar_out,
                                  taggable: ""
                                },
                                on: { input: _vm.inputChassisOut },
                                model: {
                                  value: _vm.form.out.chassis,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.out, "chassis", $$v)
                                  },
                                  expression: "form.out.chassis"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "chassis" } }, [
                                _vm._v("Chassis:")
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                id: "placa_out"
                              },
                              model: {
                                value: _vm.form.out.placa,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "placa", $$v)
                                },
                                expression: "form.out.placa"
                              }
                            },
                            [_vm._v("Placa Out")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                id: "sticker_seal_out",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled
                              },
                              model: {
                                value: _vm.form.out.sticker_seal,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "sticker_seal", $$v)
                                },
                                expression: "form.out.sticker_seal"
                              }
                            },
                            [_vm._v("Sticker Seal")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                id: "bottle_pack_out",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled
                              },
                              model: {
                                value: _vm.form.out.bottle_pack,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "bottle_pack", $$v)
                                },
                                expression: "form.out.bottle_pack"
                              }
                            },
                            [_vm._v("Bottle Pack/Kit seal")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                id: "bottle_seal_out"
                              },
                              model: {
                                value: _vm.form.out.bottle_seal,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "bottle_seal", $$v)
                                },
                                expression: "form.out.bottle_seal"
                              }
                            },
                            [_vm._v("Bottle Seal")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                id: "plastic"
                              },
                              model: {
                                value: _vm.form.out.plastic,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "plastic", $$v)
                                },
                                expression: "form.out.plastic"
                              }
                            },
                            [_vm._v("Plastic/lata seal:")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "mt-2 mr-2" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.out.type,
                              expression: "form.out.type"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "type_out",
                            id: "type_exp",
                            value: "EXP",
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_out ||
                              _vm.outDisabled
                          },
                          domProps: {
                            checked: _vm._q(_vm.form.out.type, "EXP")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form.out, "type", "EXP")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("EXP")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.out.type,
                              expression: "form.out.type"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "type_out",
                            id: "type_pos",
                            value: "POS",
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_out ||
                              _vm.outDisabled
                          },
                          domProps: {
                            checked: _vm._q(_vm.form.out.type, "POS")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form.out, "type", "POS")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("POS")])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "col-xs-12 col-md-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.out.type,
                              expression: "form.out.type"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "type_out",
                            id: "type_pla",
                            value: "PLA",
                            disabled:
                              _vm.total_loss ||
                              !_vm.puede_editar_out ||
                              _vm.outDisabled
                          },
                          domProps: {
                            checked: _vm._q(_vm.form.out.type, "PLA")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form.out, "type", "PLA")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("PLA")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-2" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                stretch: "",
                                id: "ventilacion_out"
                              },
                              model: {
                                value: _vm.form.out.ventilacion,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "ventilacion", $$v)
                                },
                                expression: "form.out.ventilacion"
                              }
                            },
                            [_vm._v("Ventilación")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-2" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                stretch: "",
                                id: "te_out"
                              },
                              model: {
                                value: _vm.form.out.te,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "te", $$v)
                                },
                                expression: "form.out.te"
                              }
                            },
                            [_vm._v("Te")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-1" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.out.full,
                                  expression: "form.out.full"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss ||
                                  !_vm.puede_editar_out ||
                                  _vm.outDisabled
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.out.full)
                                  ? _vm._i(_vm.form.out.full, null) > -1
                                  : _vm.form.out.full
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.form.out.full,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.form.out,
                                          "full",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.form.out,
                                          "full",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.form.out, "full", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Full")])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "textarea-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_out,
                                readonly: _vm.outDisabled,
                                id: "remarks_out"
                              },
                              model: {
                                value: _vm.form.out.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.out, "remarks", $$v)
                                },
                                expression: "form.out.remarks"
                              }
                            },
                            [_vm._v("Remarks:")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "details",
              {
                staticClass: "card card--collapsible mt-3 mb-3",
                attrs: { id: "MAC" }
              },
              [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.mac.inspection,
                                  expression: "form.mac.inspection"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.mac.inspection)
                                  ? _vm._i(_vm.form.mac.inspection, null) > -1
                                  : _vm.form.mac.inspection
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.mac.inspection,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "inspection",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "inspection",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.mac, "inspection", $$c)
                                    }
                                  },
                                  _vm.changeInspeccionM
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Inspection")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_inspection_m",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              model: {
                                value: _vm.form.mac.inspection_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "inspection_date", $$v)
                                },
                                expression: "form.mac.inspection_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["mac.inspection_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona inspection"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina,
                                id: "hour_man_m"
                              },
                              model: {
                                value: _vm.form.mac.hour_man,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "hour_man", $$v)
                                },
                                expression: "form.mac.hour_man"
                              }
                            },
                            [_vm._v("Hour Man:\n                  ")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "in_servi",
                                type: "dateTime",
                                locale: "es",
                                format: "YYYY-MM-DD HH:mm",
                                formatted: "YYYY-MM-DD HH:mm",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              model: {
                                value: _vm.form.mac.in_servi,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "in_servi", $$v)
                                },
                                expression: "form.mac.in_servi"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("In Servi")])
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.mac.estimate,
                                  expression: "form.mac.estimate"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.mac.estimate)
                                  ? _vm._i(_vm.form.mac.estimate, null) > -1
                                  : _vm.form.mac.estimate
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.mac.estimate,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "estimate",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "estimate",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.mac, "estimate", $$c)
                                    }
                                  },
                                  _vm.changeEstimateM
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Estimate")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_estimate_m",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              model: {
                                value: _vm.form.mac.estimate_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "estimate_date", $$v)
                                },
                                expression: "form.mac.estimate_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["mac.estimate_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona estimate"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                vMoney: "",
                                format: _vm.decimal2,
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina,
                                id: "amount_m"
                              },
                              model: {
                                value: _vm.form.mac.amount,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "amount", $$v)
                                },
                                expression: "form.mac.amount"
                              }
                            },
                            [_vm._v("Amount:")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field select2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select2-field select2-field--stretch"
                          },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "pti_type",
                                label: "name",
                                options: _vm.OptionsPtiTypes,
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              on: { input: _vm.inputPtiType },
                              model: {
                                value: _vm.selectedPtiType,
                                callback: function($$v) {
                                  _vm.selectedPtiType = $$v
                                },
                                expression: "selectedPtiType"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "pti_type" } }, [
                              _vm._v("Pti Type:")
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.mac.approved,
                                  expression: "form.mac.approved"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.mac.approved)
                                  ? _vm._i(_vm.form.mac.approved, null) > -1
                                  : _vm.form.mac.approved
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.mac.approved,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "approved",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "approved",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.mac, "approved", $$c)
                                    }
                                  },
                                  _vm.changeApprovedM
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Approved")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_approved_m",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              model: {
                                value: _vm.form.mac.approved_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "approved_date", $$v)
                                },
                                expression: "form.mac.approved_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["mac.approved_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona approved"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field select2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select2-field select2-field--stretch"
                          },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "model_machine",
                                taggable: "",
                                options: _vm.modelMachine,
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              on: { input: _vm.inputModelMachine },
                              model: {
                                value: _vm.form.mac.model_machine,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "model_machine", $$v)
                                },
                                expression: "form.mac.model_machine"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "model_machine" } }, [
                              _vm._v("Model Machine:")
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.mac.invoice,
                                  expression: "form.mac.invoice"
                                }
                              ],
                              attrs: {
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina,
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.mac.invoice)
                                  ? _vm._i(_vm.form.mac.invoice, null) > -1
                                  : _vm.form.mac.invoice
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.mac.invoice,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "invoice",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "invoice",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.mac, "invoice", $$c)
                                    }
                                  },
                                  _vm.changeInvoiceM
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Invoice")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_invoice_m",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              model: {
                                value: _vm.form.mac.invoice_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "invoice_date", $$v)
                                },
                                expression: "form.mac.invoice_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["mac.invoice_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona invoice"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.mac.repaired,
                                  expression: "form.mac.repaired"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.mac.repaired)
                                  ? _vm._i(_vm.form.mac.repaired, null) > -1
                                  : _vm.form.mac.repaired
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.mac.repaired,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "repaired",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.mac,
                                            "repaired",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.mac, "repaired", $$c)
                                    }
                                  },
                                  _vm.changeRepairedM
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Repaired")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_repaired_m",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina
                              },
                              model: {
                                value: _vm.form.mac.repaired_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "repaired_date", $$v)
                                },
                                expression: "form.mac.repaired_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["mac.repaired_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona repaired"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "textarea-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_maquina,
                                id: "remarks_m"
                              },
                              model: {
                                value: _vm.form.mac.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.mac, "remarks", $$v)
                                },
                                expression: "form.mac.remarks"
                              }
                            },
                            [_vm._v("Remarks:\n                  ")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "details",
              {
                staticClass: "card card--collapsible mt-3 mb-3",
                attrs: { id: "BOX" }
              },
              [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.box.inspection,
                                  expression: "form.box.inspection"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.box.inspection)
                                  ? _vm._i(_vm.form.box.inspection, null) > -1
                                  : _vm.form.box.inspection
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.box.inspection,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "inspection",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "inspection",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.box, "inspection", $$c)
                                    }
                                  },
                                  _vm.changeInspeccionB
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Inspection")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_inspection_b",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              model: {
                                value: _vm.form.box.inspection_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.box, "inspection_date", $$v)
                                },
                                expression: "form.box.inspection_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["box.inspection_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona inspection"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja,
                                id: "hour_man_b"
                              },
                              model: {
                                value: _vm.form.box.hour_man,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.box, "hour_man", $$v)
                                },
                                expression: "form.box.hour_man"
                              }
                            },
                            [_vm._v("Hour Man:\n                  ")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.box.estimate,
                                  expression: "form.box.estimate"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.box.estimate)
                                  ? _vm._i(_vm.form.box.estimate, null) > -1
                                  : _vm.form.box.estimate
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.box.estimate,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "estimate",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "estimate",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.box, "estimate", $$c)
                                    }
                                  },
                                  _vm.changeEstimateB
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Estimate")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_estimate_b",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              model: {
                                value: _vm.form.box.estimate_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.box, "estimate_date", $$v)
                                },
                                expression: "form.box.estimate_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["box.estimate_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona estimate"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                stretch: "",
                                vMoney: "",
                                format: _vm.decimal2,
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja,
                                id: "amount_b"
                              },
                              model: {
                                value: _vm.form.box.amount,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.box, "amount", $$v)
                                },
                                expression: "form.box.amount"
                              }
                            },
                            [_vm._v("Amount:")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.box.approved,
                                  expression: "form.box.approved"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.box.approved)
                                  ? _vm._i(_vm.form.box.approved, null) > -1
                                  : _vm.form.box.approved
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.box.approved,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "approved",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "approved",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.box, "approved", $$c)
                                    }
                                  },
                                  _vm.changeApprovedB
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Approved")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_approved_b",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              model: {
                                value: _vm.form.box.approved_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.box, "approved_date", $$v)
                                },
                                expression: "form.box.approved_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["box.approved_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona approved"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.box.invoice,
                                  expression: "form.box.invoice"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.box.invoice)
                                  ? _vm._i(_vm.form.box.invoice, null) > -1
                                  : _vm.form.box.invoice
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.box.invoice,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "invoice",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "invoice",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.box, "invoice", $$c)
                                    }
                                  },
                                  _vm.changeInvoiceB
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Invoice")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_invoice_b",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              model: {
                                value: _vm.form.box.invoice_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.box, "invoice_date", $$v)
                                },
                                expression: "form.box.invoice_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["box.invoice_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona invoice"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c("p", [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.box.repaired,
                                  expression: "form.box.repaired"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              domProps: {
                                checked: Array.isArray(_vm.form.box.repaired)
                                  ? _vm._i(_vm.form.box.repaired, null) > -1
                                  : _vm.form.box.repaired
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.form.box.repaired,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "repaired",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.box,
                                            "repaired",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form.box, "repaired", $$c)
                                    }
                                  },
                                  _vm.changeRepairedB
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Repaired")])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                      _c("div", { staticClass: "form-field" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "datepicker-field datepicker-field--stretch"
                          },
                          [
                            _c("date-picker", {
                              attrs: {
                                id: "date_repaired_b",
                                locale: "es",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja
                              },
                              model: {
                                value: _vm.form.box.repaired_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.box, "repaired_date", $$v)
                                },
                                expression: "form.box.repaired_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Date:")]),
                            _vm._v(" "),
                            _vm.errores["box.repaired_date"]
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        "Este campo es requerido cuando selecciona repaired"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "textarea-field",
                            {
                              attrs: {
                                stretch: "",
                                disabled:
                                  _vm.total_loss || !_vm.puede_editar_caja,
                                id: "remarks_b"
                              },
                              model: {
                                value: _vm.form.box.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.box, "remarks", $$v)
                                },
                                expression: "form.box.remarks"
                              }
                            },
                            [_vm._v("Remarks:\n                  ")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card__content" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "select2-field select2-field--dropdown-top select2-field--stretch"
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "status",
                              label: "name",
                              options: _vm.OptionsStatus,
                              disabled:
                                !_vm.puede_editar_status &&
                                _vm.total_loss &&
                                !_vm.puede_editar_in &&
                                !_vm.puede_editar_out
                            },
                            on: { input: _vm.inputStatus },
                            model: {
                              value: _vm.selectedStatus,
                              callback: function($$v) {
                                _vm.selectedStatus = $$v
                              },
                              expression: "selectedStatus"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "status" } }, [
                            _vm._v("Status:")
                          ])
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "select2-field select2-field--dropdown-top select2-field--stretch"
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "type_wash",
                              label: "name",
                              options: _vm.OptionsTypeWash,
                              disabled:
                                _vm.total_loss ||
                                (!_vm.puede_editar_in && !_vm.puede_editar_out)
                            },
                            on: { input: _vm.inputTypeWash },
                            model: {
                              value: _vm.selectedTypeWash,
                              callback: function($$v) {
                                _vm.selectedTypeWash = $$v
                              },
                              expression: "selectedTypeWash"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "type_wash" } }, [
                            _vm._v("Type Wash:")
                          ])
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "45%",
            height: "auto",
            scrollable: "",
            name: "mostarImagen"
          }
        },
        [
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("img", {
              staticClass: "figure-img img-fluid rounded",
              staticStyle: { "max-height": "500px" },
              attrs: { src: _vm.imagePreview }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "editarDetalles",
            width: "80%",
            height: "auto",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [
          _c("editar-detalles", {
            attrs: { number: _vm.form.number, secuencia: _vm.form.secuencia },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("editarDetalles")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "mostrarAtajos",
            width: "40%",
            height: "auto",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [
          _c("atajos", {
            attrs: { atajos: _vm.atajos },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("mostrarAtajos")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "summary",
      { staticClass: "card__title card__title--bg-success" },
      [_c("h5", [_vm._v("IN")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-xs-12 col-md-2" }, [
      _c("b", [_vm._v("Type:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("summary", { staticClass: "card__title card__title--bg-info" }, [
      _c("h5", [_vm._v("OUT")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-xs-12 col-md-3" }, [
      _c("b", [_vm._v("Type:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "summary",
      { staticClass: "card__title card__title--bg-secondary" },
      [_c("h5", [_vm._v("Machine")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "summary",
      { staticClass: "card__title card__title--bg-warning" },
      [_c("h5", [_vm._v("Box")])]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c3ef654", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c3ef654","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/sistema/EditarUnidad.vue
// module id = 345
// module chunks = 0